// SidebarContent.js
import React, { Component } from "react";
import MetisMenu from "metismenujs";
import { withRouter, Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

class SidebarContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            authUser: null,
        };
    }

    componentDidMount() {
        const user = localStorage.getItem("authUser")
            ? JSON.parse(localStorage.getItem("authUser"))
            : null;

        this.setState({ authUser: user }, () => this.initMenu());
    }

    componentDidUpdate(prevProps) {
        if (this.props.type !== prevProps.type) {
            this.initMenu();
        }
    }

    initMenu() {
        new MetisMenu("#side-menu");

        let matchingMenuItem = null;
        let ul = document.getElementById("side-menu");
        let items = ul.getElementsByTagName("a");

        for (let i = 0; i < items.length; ++i) {
            if (this.props.location.pathname === items[i].pathname) {
                matchingMenuItem = items[i];
                break;
            }
        }

        if (matchingMenuItem) {
            this.activateParentDropdown(matchingMenuItem);
        }
    }

    activateParentDropdown(item) {
        item.classList.add("active");
        const parent = item.parentElement;

        if (parent) {
            parent.classList.add("mm-active");

            const parent2 = parent.parentElement;
            if (parent2) {
                parent2.classList.add("mm-show");

                const parent3 = parent2.parentElement;
                if (parent3) {
                    parent3.classList.add("mm-active");
                    parent3.childNodes[0].classList.add("mm-active");

                    const parent4 = parent3.parentElement;
                    if (parent4) parent4.classList.add("mm-active");
                }
            }
        }
        return false;
    }

    // ================================
    // MASTER ADMIN GETS FULL ACCESS
    // SUB-ADMIN GETS PERMISSION BASED ACCESS
    // ================================
    hasPermission = (perm) => {
        const { authUser } = this.state;

        if (!authUser) return false;

        // MASTER ADMIN → Full access (important part)
        if (authUser.userType === "ADMIN") return true;

        // SUB ADMIN → FULL ACCESS
    if (authUser.permissions?.includes("FULL_ACCESS")) return true;

        // SUB ADMIN ACCESS BASED ON PERMISSIONS ARRAY
        return (authUser.permissions || []).includes(perm);
    };

    render() {
        const { authUser } = this.state;
        const isMasterAdmin = authUser?.userType === "ADMIN" ||
    authUser?.permissions?.includes("FULL_ACCESS");

        return (
            <React.Fragment>
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">

                        {/* Dashboard */}
                        <li>
                            <Link to="/dashboard" className="waves-effect">
                                <i className="bx bx-home-circle"></i>
                                <span>{this.props.t("Dashboard")}</span>
                            </Link>
                        </li>

                        {/* Vehicle */}
                        {this.hasPermission("VEHICLE_LOAD") && (
                            <li>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="bx bxs-bus-school"></i>
                                    <span>Vehicle</span>
                                </Link>
                                <ul className="sub-menu">
                                    <li><Link to="GpsUser">GPS User</Link></li>
                                    <li><Link to="vehicleList">Vehicle List</Link></li>
                                    <li><Link to="GpsDeviceDataList">GPS Device Data List</Link></li>
                                </ul>
                            </li>
                        )}

                        {/* Business Listing */}
                        {this.hasPermission("BUSINESS_LISTING") && (
                            <li>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="bx bx-list-ol"></i>
                                    <span>Business Listing</span>
                                </Link>
                                <ul className="sub-menu">
                                    <li><Link to="AddBusinessProfile">Add Business Profile</Link></li>
                                    <li><Link to="transporterList">Transporter List</Link></li>
                                    <li><Link to="packersAndMovers">Packers & Movers</Link></li>
                                </ul>
                            </li>
                        )}

                        {/* Users */}
                        {this.hasPermission("USERS_LIST") && (
                            <li>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="bx bx-user"></i>
                                    <span>Users List</span>
                                </Link>
                                <ul className="sub-menu">
                                    <li><Link to="AddUser">Add User</Link></li>
                                    <li><Link to="MtgpsUserList">MTGPS Users</Link></li>
                                    <li><Link to="MtUsersList">Moverstrip Users</Link></li>
                                </ul>
                            </li>
                        )}

                        {/* --------------------------- */}
                        {/* FULL ACCESS AREA FOR MASTER ADMIN */}
                        {/* --------------------------- */}
                        {isMasterAdmin && (
                            <li>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="bx bx-lock-open"></i>
                                    <span>Manage Users</span>
                                </Link>
                                <ul className="sub-menu">
                                    <li><Link to="AdminUsersList">View Users</Link></li>
                                    <li><Link to="CreateAdminUser">Add User</Link></li>
                                </ul>
                            </li>
                        )}

                        {/* Reports */}
                        {this.hasPermission("REPORTS") && (
                            <li>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="bx bxs-chart"></i>
                                    <span>Report</span>
                                </Link>
                                <ul className="sub-menu">
                                    <li><Link to="subscriberUser">Subscriber User</Link></li>
                                    <li><Link to="unsubcriberUser">Unsubscriber User</Link></li>
                                    <li><Link to="todayUser">Today User</Link></li>
                                </ul>
                            </li>
                        )}

                        {/* Rate Card */}
                        {this.hasPermission("RATE_CARD") && (
                            <li>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="bx bx-card"></i>
                                    <span>Rate Card</span>
                                </Link>
                                <ul className="sub-menu">
                                    <li><Link to="RateCard">Add Rate Card</Link></li>
                                </ul>
                            </li>
                        )}

                        {/* live vehicle */}
                        {this.hasPermission("LIVE_VEHICLE_LISTS") && (
                            <li>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="bx bxs-truck"></i>
                                    <span>Live Vehicles</span>
                                </Link>
                                <ul className="sub-menu">
                                    <li><Link to="/LiveVehiclesLists">Live Vehicle List</Link></li>
                                </ul>
                            </li>
                        )}

                        {/* Help */}
                        <li>
                            <Link to="/help" className="waves-effect">
                                <i className="bx bxs-help-circle"></i>
                                <span>Help</span>
                            </Link>
                        </li>

                        {/* Contact */}
                        {this.hasPermission("CONTACT_US") && (
                            <li>
                                <Link to="/ContactUs" className="waves-effect">
                                    <i className="bx bxs-contact"></i>
                                    <span>Contact Us</span>
                                </Link>
                            </li>
                        )}

                    </ul>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(withNamespaces()(SidebarContent));
